<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%;">
			<el-dialog :title="titmc" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="12">
            <addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="经费" prop="gljf">
							<el-input type="type" class="from-el-input" placeholder="防汛管理经费" v-model.trim="ruleForm.gljf" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item type="type" label="行政责任人" prop="xzzrr">
							<el-input type="type" class="from-el-input" placeholder="防汛行政责任人" v-model.trim="ruleForm.xzzrr" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="联系方式" prop="xzlxfs">
							<el-input type="type" class="from-el-input" placeholder="防汛行政责任人联系方式" v-model.trim="ruleForm.xzlxfs" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
        <el-row>
        	<el-col :span="12">
        		<el-form-item type="type" label="管理责任人" prop="glzrr">
        			<el-input type="type" class="from-el-input" placeholder="管理经费责任人" v-model.trim="ruleForm.glzrr" :disabled="states=='ck'"></el-input>
        		</el-form-item>
        	</el-col>
        	<el-col :span="12">
        		<el-form-item type="type" label="联系方式" prop="gllxfs">
        			<el-input type="type" class="from-el-input" placeholder="管理经费责任人联系方式" v-model.trim="ruleForm.gllxfs" :disabled="states=='ck'"></el-input>
        		</el-form-item>
        	</el-col>
        </el-row>
        <el-row>
        	<el-col :span="12">
        		<el-form-item type="type" label="落实情况" prop="lsqk">
              <el-select :disabled = "states=='ck'" v-model.trim="ruleForm.lsqk" class="from-el-input" placeholder="落实情况">
              	<el-option v-for="(item,i) in lslist" :key="i" :label="item.name" :value="item.code">
              	</el-option>
              </el-select>
        		</el-form-item>
        	</el-col>
        </el-row>
				<el-row v-if="states=='xz'||states=='bj'">
					<el-col :span="24" style="display:flex">
						<div class="titna">
							<span class="addSpan">附件</span>
						</div>
						<div class="fujian">
							<el-upload class="upload-demo" drag action multiple :on-remove="handleRemove" :on-change="changes" :file-list="fileList" :limit="5" :auto-upload="false">
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									将文件拖到此处，或
									<em>点击上传</em>
								</div>
							</el-upload>
							<div class="fujian fujians" v-if="filetabledata.length!=0">
								<ul class="fjhxlist">
									<li v-for="(item,i) in filetabledata" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
										<div class="names cz">
											<el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
											<el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)" class="btnmargin"></el-button>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row v-if="states=='ck' && filetabledata.length !== 0">
					<el-col :span="24" style="display:flex">
						<div class="titna">
							<span class="addSpan">附件</span>
						</div>
						<div class="fujian">
							<ul class="fjhxlist">
								<li v-if="filetabledata.length==0" style="width:100%;height:80px;line-height: 80px;color:#ccc">暂无附件,请上传！</li>
								<li v-for="(item,i) in filetabledata" :key="i" v-if="filetabledata.length!=0">
                  <div class="names" style="text-align: left;">{{item.sourceName}}</div>
									<div class="names cz">
										<el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
										<el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)" class="btnmargin"></el-button>
									</div>
								</li>
							</ul>
						</div>
					</el-col>
				</el-row>
        <el-row>
          <el-col :span="12">
          	<el-form-item type="type" label="登记人" prop="djr">
          		<el-input type="type" class="from-el-input" placeholder="登记人" v-model.trim="ruleForm.djr" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
        	<el-col :span="12">
        		<el-form-item type="type" label="登记日期" prop="fdate">
              <el-date-picker v-model.trim="ruleForm.fdate" align="right" type="date" value-format="yyyy-MM-dd" class="from-el-input-item" placeholder="登记日期" :disabled="states=='ck'">	</el-date-picker>
        		</el-form-item>
        	</el-col>
        </el-row>
				<span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button v-if="states !== 'ck'" @click="cancel()" type="warning">取 消</el-button>
            <el-button v-if="states == 'xz'" type="success" @click="xzdeteRmine('ruleForm','xz')">保 存</el-button>
            <el-button v-if="states == 'bj'" type="success" @click="xzdeteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
			</el-dialog>
		</el-form>
	</div>
</template>
<script>
  import { ydbjbxxQuery, fxgljfSave, fxgljfUpdate, dictioninfo, deleteFile } from "@/api/api";
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  import axios from 'axios'
	let date = new Date()
  const currentFdate = date.getFullYear() + '-' + (date.getMonth()+1) + '-'+ date.getDate() + ' ' + date.getHours()+':'+date.getMinutes()+':'+date.getSeconds();
	export default {
		props: {
			mystate: Array
		},
		data() {
			return {
				editDisable: false,
				dialogVisible: true, // 弹出框显示
				titmc: '新增管理经费',
				ruleForm: {
					ydbmc: '', // 淤地坝名称
          ydbCode: '',
					gljf: '', // 管理经费
          xzzrr: '',
          xzlxfs: '',
          glzrr: '',
          gllxfs: '',
          lsqk: '',
					djr: '',
					fdate: String(currentFdate)
				},
        lslist: [],
				rules: {
					ydbmc: [
						{ required: true, message: '请输入必填项', trigger: 'blur' }
						// { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					gljf: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						// { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
          xzzrr: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          xzlxfs: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          glzrr: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          gllxfs: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          lsqk: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
					fdate: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
          djr: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
          ]
				},

				Sid: '',
				states: '',
				fullscreen: false,
				statusId: '', // 状态id
				parentid: '',
				yaflId: '',
				fileList: [], // 图片
				filetabledata: [], // 回显附件
        currentData: '',
        row: null,
        fileUrl: '',
			}
		},
		cerate() {
			// 初始化数据
		},
		methods: {
      //获取防汛管理经费状态数字字典
      getgljfztinfo() {
        let params = {
          type: 'fxgljf',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.lslist = res.data;
        })
      },
      list(params) {
      	let _this = this;
      	ydbjbxxQuery(params).then((res) => {
      	  if (res.data.length !== 1) {
      	    _this.$notify({
      	      title: "提示",
      	      message: "请选择淤地坝",
      	      type: "warning"
      	    });
      	  } else {
      	    _this.ruleForm.ydbCode = res.data[0].ydbCode;
      	    _this.ruleForm.ydbmc = res.data[0].ydbName;
      	  }
      	})
      },
      treeClose(){
      	// let params = {};
      	// this.list(params);
      },
      objdata(data) {
      	let params = {
      		ydbCode:data.ydbCode
      	};
      	this.list(params);
      },
			handleClose(done) {
				this.dialogVisible = false
				this.$emit('getcancel', { dialogVisible: this.dialogVisible })
			},
			cancel() {
				// 取消
				this.dialogVisible = false
				this.$emit('getcancel', { dialogVisible: this.dialogVisible })
			},
			xzdeteRmine(formName, states) { //确定
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }; // 添加请求头
            if (this.fileList.length != 0) {
              let formData = new FormData();
              this.fileList.forEach((el, index) => {
                formData.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });

              axios.post('/userApi/minio/updateFileMulti', formData, config).then(res => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "success",
                  });
                  this.fileUrl = res.data.data;
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "warning",
                  });
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              if (states == 'xz') {
                let params = {
                  ydbName: _this.ruleForm.ydbmc, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbFxgljfJe: _this.ruleForm.gljf, //防汛管理经费金额
                  ydbFxxzZrr: _this.ruleForm.xzzrr, //防汛行政责任人
                  ydbFxxzZrrLxfs: _this.ruleForm.xzlxfs, //防汛行政责任人联系方式
                  ydbGljfFzr: _this.ruleForm.glzrr, //管理经费负责人
                  ydbGljfFzrLxfs: _this.ruleForm.gllxfs, //管理经费负责人	联系方式
                  status: _this.ruleForm.lsqk, //落实状况
                  ydbFuJian: _this.fileUrl, //附件
                  ydbDjr: _this.ruleForm.djr, //登记人
                  ydbDjqr: _this.ruleForm.fdate, //登记日期
                };
                fxgljfSave(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("adddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              } else {
                let zhuangtai;
                if (_this.ruleForm.lsqk === '已落实') {
                  zhuangtai = 0;
                } else {
                  zhuangtai = 1;
                }
                let params = {
                  ydbName: _this.ruleForm.ydbmc, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbFxgljfJe: _this.ruleForm.gljf, //防汛管理经费金额
                  ydbFxxzZrr: _this.ruleForm.xzzrr, //防汛行政责任人
                  ydbFxxzZrrLxfs: _this.ruleForm.xzlxfs, //防汛行政责任人联系方式
                  ydbGljfFzr: _this.ruleForm.glzrr, //管理经费负责人
                  ydbGljfFzrLxfs: _this.ruleForm.gllxfs, //管理经费负责人	联系方式
                  status: zhuangtai, //落实状况
                  ydbFuJian: _this.fileUrl, //附件
                  ydbDjr: _this.ruleForm.djr, //登记人
                  ydbDjqr: _this.ruleForm.fdate, //登记日期
                  id: _this.row.id
                };
                if (params.ydbFuJian === '') {
                  params.ydbFuJian = null;
                }
                fxgljfUpdate(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("bjadddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              }
            }, 200)
          }
        });
			},

			DownloadFile(index, row) {
				// 下载文件
        window.open("/userApi/minio/downloadFile/" + row.fileName);
			},
			deletesfile(index, row) {
				// 删除文件
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
        		this.filetabledata.splice(index, 1)
        	}
        })
			},

			handleRemove(file, fileList) {
				// 删除文件
        for (let i = 0; i < this.fileList.length; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(this.fileList[i], 1);
          }
        }
			},

			changes(file, fileList) {
				let num = 1024.0
				if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
					fileList.splice(fileList.length - 1, 1)
					this.$message.error('选择文件大于10M，请重新选择！')
				} else {
					this.fileList.push(file.raw)
				}
			}
		},
		components: {
      addressTree
		},
		mounted() {
      this.getgljfztinfo();
      this.states = this.mystate[0];
      this.row = this.mystate[1];
      if (this.states == 'bj' || this.states == 'ck') {
        this.currentData = this.mystate[1].ydbName; //淤地坝名称

        this.ruleForm.ydbmc = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.gljf = this.mystate[1].ydbFxgljfJe; //防汛管理经费金额
        this.ruleForm.xzzrr = this.mystate[1].ydbFxxzZrr; //防汛行政责任人
        this.ruleForm.xzlxfs = this.mystate[1].ydbFxxzZrrLxfs; //防汛行政责任人联系方式
        this.ruleForm.glzrr = this.mystate[1].ydbGljfFzr; //管理经费负责人
        this.ruleForm.gllxfs = this.mystate[1].ydbGljfFzrLxfs; //管理经费负责人联系方式
        this.ruleForm.djr = this.mystate[1].ydbDjr; //登记人
        this.ruleForm.fdate = this.mystate[1].ydbDjqr; //登记日期

        this.filetabledata = this.mystate[1].ydbFuJian;

        if (this.mystate[1].status === 0) {
          this.ruleForm.lsqk = '已落实'; //状态
        } else {
          this.ruleForm.lsqk = '未落实'; //状态
        }
      }
    }
	}
</script>

<style scoped>
  >>>.el-dialog__body {
  	height: 400px;
  	overflow: auto;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }

	.fujian {
		width: 100%;
		margin-left: 9px;
		float: left;
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 10px;
		overflow: auto;
	}

  >>>.el-input--prefix .el-input__inner {
    padding-left: 30px;
  }
</style>
